import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  DatePicker,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { AiOutlineMail, AiOutlineMobile, AiFillDelete } from "react-icons/ai";
import moment from "moment";
import "moment/locale/vi";
import dealerApi from "../api/dealerApi";
import Swal from "sweetalert2";
import debounce from "lodash.debounce";

const dataExample = {
  name: null,
  email: null,
  phone: null,
  address: null,
  type: null,
  status: null,
};
const Dealer = (props) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState(dataExample);
  const [isEditModal, setIsEditModal] = useState(false);
  const [isEditModalShow, setIsEditModalShow] = useState(false);

  const [lstDealer, setLstDealer] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [btnDeleted, setBtnDeleted] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [listDeleted, setListDeleted] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const dateFormatUTC = "DD/MM/YYYY";

  const [inputFilter, setFilter] = useState({
    name: "",
    status: null,
    type: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    getDealers();
    form.setFieldsValue(valueForm);
  }, [inputFilter, form, valueForm]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1, name: e.target.value });
  };

  const getDealersDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getDealers = () => {
    setLoading(true);

    dealerApi.getDealers(inputFilter).then((res) => {
      if (res?.results) {
        setLstDealer(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Tên người đăng ký",
      dataIndex: "name",
      render: (text) => <h3>{text}</h3>,
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      render: (text) => <h6>0{text}</h6>,
    },

    {
      title: "Email",
      dataIndex: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Ngày gửi đăng kí",
      dataIndex: "createdAt",
      render: (createdAt) => (
        <span>{moment(createdAt).format(dateFormatUTC)}</span>
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (status) => (
        <>
          {status === 1 && (
            <Tag color="green" key={status}>
              Đã liên hệ
            </Tag>
          )}
          {status === 2 && (
            <Tag color="red" key={status}>
              Hủy liên hệ
            </Tag>
          )}
          {status === 0 && (
            <Tag color="red" key={status}>
              Chưa liên hệ
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Thông tin",
      dataIndex: "type",
      render: (type) => (
        <>
          {type === 1 && (
            <Tag color="blue" key={type}>
              Đang kinh doanh Online{" "}
            </Tag>
          )}
          {type === 2 && (
            <Tag color="blue" key={type}>
              Chưa kinh doanh/Muốn hợp tác
            </Tag>
          )}
          {type === 3 && (
            <Tag color="blue" key={type}>
              Đang kinh doanh vật tư nông nghiệp
            </Tag>
          )}
        </>
      ),
    },

    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteDealer(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled Dealer',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm(dataExample);
    form.resetFields();
    setIsEditModal(false);
    setIsEditModalShow(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateDealer(values);
      } else {
        createDealer(values);
      }
    },
    [isEditModal]
  );

  const createDealer = (data) => {
    const payload = {
      name: data.name,
      email: data.email,
      phone: Number(data.phone),
      address: data.address,
      type: Number(data.type),
      status: Number(data.status) ?? 0,
    };

    dealerApi.createDealer(payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getDealers();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Tạo thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateDealer = (data) => {
    const payload = {
      name: data.name,
      email: data.email,
      phone: data.phone,
      address: data.address,
      type: Number(data.type),
      status: Number(data.status) ?? 0,
    };

    dealerApi.updateDealer(data.id, payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getDealers();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Sửa thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const confirm = Modal.confirm;

  const deleteDealer = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa Dealer này không?",
      onOk() {
        dealerApi
          .deleteDealer(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công Dealer ");
              getDealers();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteDealers = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các Dealer này không?",
      onOk() {
        dealerApi
          .deleteDealer(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công Dealer ");
              getDealers();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const showEditModal = (record) => {
    setTitleModal("Sửa đăng ký đại lý");
    setValueForm({
      id: record.id,
      name: record.name,
      email: record.email,
      phone: record.phone,
      address: record.address,
      type: record.type.toString(),
      status: record.status.toString(),
    });
    setIsEditModalShow(true);
    setIsEditModal(true);
  };
  const showCreateModal = () => {
    setTitleModal("Thêm đăng ký đại lý");
    setValueForm(dataExample);
    setIsEditModalShow(true);
    setIsEditModal(false);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên đăng ký đại lý</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                // value={inputFilter.Dealername}
                placeholder="Nhập tên ..."
                onChange={getDealersDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>

            <Col span={6}>
              <label> Thông tin</label>
              <Select
                value={inputFilter.type}
                size="large"
                placeholder="Chọn để tìm kiếm..."
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1, type: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option key="1" value="1">
                  Đang kinh doanh Online
                </Option>
                <Option key="2" value="2">
                  Chưa kinh doanh/Muốn hợp tác{" "}
                </Option>
                <Option key="3" value="3">
                  Đang kinh doanh vật tư nông nghiệp{" "}
                </Option>
              </Select>
            </Col>
            <Col span={6}>
              {" "}
              <label> Trạng thái</label>
              <Select
                value={inputFilter.status}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1, status: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option key="1" value="0">
                  Chưa liên hệ
                </Option>
                <Option key="2" value="1">
                  Đã liên hệ
                </Option>
                <Option key="3" value="2">
                  Hủy liên hệ
                </Option>
              </Select>
            </Col>
          </Row>
        </Card>
        <br />
        <br />
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}>
            <EditOutlined /> &nbsp; Thêm đăng ký đại lý
          </Button>

          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deleteDealers();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstDealer}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isEditModalShow}
        onOk={form.submit}
        onCancel={() => {
          closePopup();
        }}
        style={{
          top: 25,
        }}
      >
        <div>
          <Form
            initialValues={valueForm}
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item hidden={true} label="Id" name="id">
              <Input />
            </Form.Item>

            <Form.Item
              label="Tên người đăng ký"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên!",
                },
              ]}
            >
              <Input placeholder="Nhập tên ..." />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập email!",
                },
                {
                  type: "email",
                  message: "Email không đúng định dạng!",
                },
              ]}
            >
              <Input
                addonAfter={<AiOutlineMail />}
                placeholder="Nhập email..."
              />
            </Form.Item>
            <Form.Item
              label="Số điện thoại"
              name="phone"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập số điện thoại!",
                },
                {
                  pattern: new RegExp(/^[0-9]+$/),
                  message: "Số điện thoại không đúng định dạng!",
                },
              ]}
            >
              <Input
                addonAfter={<AiOutlineMobile />}
                placeholder="Nhập số điện thoại..."
              />
            </Form.Item>

            <Form.Item
              label="Địa chỉ"
              name="address"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập đia chỉ!",
                },
              ]}
            >
              <Input placeholder="Nhập địa chỉ..." />
            </Form.Item>

            <Form.Item label="Thông tin" name="type">
              <Select
                showArrow
                showSearch
                size="large"
                optionFilterProp="children"
                // onChange={onChangeSelectProvine}
                // filterOption={(input, option) =>
                //   option.children.toLowerCase().includes(input.toLowerCase())
                // }
                placeholder="Chọn..."
              >
                <Option key="1" value="1">
                  Đang kinh doanh Online
                </Option>
                <Option key="2" value="2">
                  Chưa kinh doanh/Muốn hợp tác{" "}
                </Option>
                <Option key="3" value="3">
                  Đang kinh doanh vật tư nông nghiệp{" "}
                </Option>
              </Select>
            </Form.Item>
            <Form.Item label="Trạng thái" name="status">
              <Select
                showArrow
                showSearch
                size="large"
                optionFilterProp="children"
                // onChange={onChangeSelectProvine}
                // filterOption={(input, option) =>
                //   option.children.toLowerCase().includes(input.toLowerCase())
                // }
                placeholder="Chọn..."
              >
                <Option key="1" value="0">
                  Chưa liên hệ
                </Option>
                <Option key="2" value="1">
                  Đã liên hệ
                </Option>
                <Option key="3" value="2">
                  Hủy liên hệ
                </Option>
              </Select>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default Dealer;
